/**
 * 根据不同语言返回SEO元数据
 * @param {string} locale 当前语言代码
 * @param {string} page 当前页面名称
 * @returns {Object} SEO元数据对象
 */
export function getSeoMetadata(locale, page) {
  // 各语言的基础SEO数据
  const seoData = {
    // 英语 - 默认语言，面向国际用户
    en: {
      siteName: "Ugly Avatar",
      home: {
        title: "Ugly-Cute Avatar Generator - Create Fun Cartoon Avatars",
        description:
          "Create fun, unique, and memorable cartoon avatars with the Ugly Avatar generator. Customize hair color, background color, and expressions, save and share your favorite designs.",
        keywords:
          "avatar generator,cartoon avatar,ugly-cute avatar,random avatar,personalized avatar,SVG avatar,free avatar",
      },
      generator: {
        title: "Create Your Ugly-Cute Avatar - Fun Cartoon Avatar Generator",
        description:
          "Generate your own unique ugly-cute cartoon avatar with our free online tool. Customize hair, colors, expressions and download or share with friends.",
        keywords:
          "generate avatar,custom cartoon face,avatar creator,funny avatar,personalized cartoon",
      },
      gallery: {
        title: "My Avatar Collection - Ugly Avatar Gallery",
        description:
          "View and manage your saved ugly-cute cartoon avatars. Download, share, or delete your custom cartoon avatar collection.",
        keywords:
          "avatar gallery,saved avatars,cartoon collection,avatar management,download avatars",
      },
    },
    // 中文 - 针对中国市场
    zh: {
      siteName: "丑萌头像",
      home: {
        title: "丑萌头像生成器 - 创建有趣的卡通头像",
        description:
          "使用丑萌头像生成器创建有趣、独特且令人难忘的卡通头像。自定义发色、背景颜色和表情，保存并分享您喜爱的设计。",
        keywords:
          "头像生成器,卡通头像,丑萌头像,随机头像,个性化头像,SVG头像,免费头像",
      },
      generator: {
        title: "创建您的丑萌头像 - 有趣的卡通头像生成器",
        description:
          "使用我们免费的在线工具生成您自己独特的丑萌卡通头像。自定义发型、颜色、表情，然后下载或与朋友分享。",
        keywords: "生成头像,自定义卡通脸,头像创建器,搞笑头像,个性化卡通",
      },
      gallery: {
        title: "我的头像收藏 - 丑萌头像画廊",
        description:
          "查看和管理您保存的丑萌卡通头像。下载、分享或删除您的自定义卡通头像收藏。",
        keywords: "头像画廊,保存的头像,卡通收藏,头像管理,下载头像",
      },
    },
    // 德语 - 针对德国、奥地利等德语国家
    de: {
      siteName: "Hässlich-Süßer Avatar",
      home: {
        title:
          "Hässlich-Süßer Avatar Generator - Erstelle lustige Cartoon-Avatare",
        description:
          "Erstelle lustige, einzigartige und unvergessliche Cartoon-Avatare mit dem Hässlich-Süßer Avatar Generator. Passe Haarfarbe, Hintergrundfarbe und Ausdrücke an, speichere und teile deine Lieblingsdesigns.",
        keywords:
          "Avatar-Generator,Cartoon-Avatar,hässlich-süßer Avatar,Zufalls-Avatar,personalisierter Avatar,SVG-Avatar,kostenloser Avatar",
      },
      generator: {
        title:
          "Erstelle deinen Hässlich-Süßen Avatar - Lustiger Cartoon-Avatar-Generator",
        description:
          "Generiere deinen eigenen einzigartigen hässlich-süßen Cartoon-Avatar mit unserem kostenlosen Online-Tool. Passe Haare, Farben, Ausdrücke an und lade ihn herunter oder teile ihn mit Freunden.",
        keywords:
          "Avatar generieren,benutzerdefiniertes Cartoon-Gesicht,Avatar-Ersteller,lustiger Avatar,personalisierter Cartoon",
      },
      gallery: {
        title: "Meine Avatar-Sammlung - Hässlich-Süßer Avatar Galerie",
        description:
          "Sieh dir deine gespeicherten hässlich-süßen Cartoon-Avatare an und verwalte sie. Lade deine benutzerdefinierte Cartoon-Avatar-Sammlung herunter, teile oder lösche sie.",
        keywords:
          "Avatar-Galerie,gespeicherte Avatare,Cartoon-Sammlung,Avatar-Verwaltung,Avatare herunterladen",
      },
    },
    // 越南语 - 针对越南市场
    vi: {
      siteName: "Ugly Avatar",
      home: {
        title:
          "Trình tạo Hình đại diện Xấu-Dễ thương - Tạo Hình đại diện Hoạt hình Vui nhộn",
        description:
          "Tạo hình đại diện hoạt hình vui nhộn, độc đáo và đáng nhớ với trình tạo Ugly Avatar. Tùy chỉnh màu tóc, màu nền và biểu cảm, lưu và chia sẻ thiết kế yêu thích của bạn.",
        keywords:
          "trình tạo hình đại diện,hình đại diện hoạt hình,hình đại diện xấu-dễ thương,hình đại diện ngẫu nhiên,hình đại diện cá nhân hóa,hình đại diện SVG,hình đại diện miễn phí",
      },
      generator: {
        title:
          "Tạo Hình đại diện Xấu-Dễ thương - Trình tạo Hình đại diện Hoạt hình Vui nhộn",
        description:
          "Tạo hình đại diện hoạt hình xấu-dễ thương độc đáo của riêng bạn với công cụ trực tuyến miễn phí của chúng tôi. Tùy chỉnh tóc, màu sắc, biểu cảm và tải xuống hoặc chia sẻ với bạn bè.",
        keywords:
          "tạo hình đại diện,khuôn mặt hoạt hình tùy chỉnh,trình tạo hình đại diện,hình đại diện hài hước,hoạt hình cá nhân hóa",
      },
      gallery: {
        title: "Bộ sưu tập Hình đại diện của tôi - Thư viện Ugly Avatar",
        description:
          "Xem và quản lý hình đại diện hoạt hình xấu-dễ thương đã lưu của bạn. Tải xuống, chia sẻ hoặc xóa bộ sưu tập hình đại diện hoạt hình tùy chỉnh của bạn.",
        keywords:
          "thư viện hình đại diện,hình đại diện đã lưu,bộ sưu tập hoạt hình,quản lý hình đại diện,tải xuống hình đại diện",
      },
    },
    // 泰语 - 针对泰国市场
    th: {
      siteName: "Ugly Avatar",
      home: {
        title: "เครื่องสร้างอวาตาร์น่าเกลียดน่ารัก - สร้างอวาตาร์การ์ตูนสนุกๆ",
        description:
          "สร้างอวาตาร์การ์ตูนที่สนุก เป็นเอกลักษณ์ และน่าจดจำด้วยเครื่องสร้าง Ugly Avatar ปรับแต่งสีผม สีพื้นหลัง และการแสดงออก บันทึกและแชร์การออกแบบที่คุณชื่นชอบ",
        keywords:
          "เครื่องสร้างอวาตาร์,อวาตาร์การ์ตูน,อวาตาร์น่าเกลียดน่ารัก,อวาตาร์แบบสุ่ม,อวาตาร์ส่วนบุคคล,อวาตาร์ SVG,อวาตาร์ฟรี",
      },
      generator: {
        title:
          "สร้างอวาตาร์น่าเกลียดน่ารักของคุณ - เครื่องสร้างอวาตาร์การ์ตูนสนุกๆ",
        description:
          "สร้างอวาตาร์การ์ตูนน่าเกลียดน่ารักที่เป็นเอกลักษณ์ของคุณเองด้วยเครื่องมือออนไลน์ฟรีของเรา ปรับแต่งทรงผม สี การแสดงออก และดาวน์โหลดหรือแชร์กับเพื่อน",
        keywords:
          "สร้างอวาตาร์,ใบหน้าการ์ตูนแบบกำหนดเอง,เครื่องสร้างอวาตาร์,อวาตาร์ตลก,การ์ตูนส่วนบุคคล",
      },
      gallery: {
        title: "คอลเลกชันอวาตาร์ของฉัน - แกลเลอรี Ugly Avatar",
        description:
          "ดูและจัดการอวาตาร์การ์ตูนน่าเกลียดน่ารักที่คุณบันทึกไว้ ดาวน์โหลด แชร์ หรือลบคอลเลกชันอวาตาร์การ์ตูนที่คุณปรับแต่ง",
        keywords:
          "แกลเลอรีอวาตาร์,อวาตาร์ที่บันทึกไว้,คอลเลกชันการ์ตูน,การจัดการอวาตาร์,ดาวน์โหลดอวาตาร์",
      },
    },
    // 印尼语 - 针对印度尼西亚市场
    id: {
      siteName: "Ugly Avatar",
      home: {
        title:
          "Generator Avatar Jelek-Lucu - Buat Avatar Kartun yang Menyenangkan",
        description:
          "Buat avatar kartun yang menyenangkan, unik, dan berkesan dengan generator Ugly Avatar. Sesuaikan warna rambut, warna latar belakang, dan ekspresi, simpan dan bagikan desain favorit Anda.",
        keywords:
          "generator avatar,avatar kartun,avatar jelek-lucu,avatar acak,avatar dipersonalisasi,avatar SVG,avatar gratis",
      },
      generator: {
        title:
          "Buat Avatar Jelek-Lucu Anda - Generator Avatar Kartun yang Menyenangkan",
        description:
          "Hasilkan avatar kartun jelek-lucu unik Anda sendiri dengan alat online gratis kami. Sesuaikan rambut, warna, ekspresi dan unduh atau bagikan dengan teman.",
        keywords:
          "hasilkan avatar,wajah kartun kustom,pembuat avatar,avatar lucu,kartun dipersonalisasi",
      },
      gallery: {
        title: "Koleksi Avatar Saya - Galeri Ugly Avatar",
        description:
          "Lihat dan kelola avatar kartun jelek-lucu yang telah Anda simpan. Unduh, bagikan, atau hapus koleksi avatar kartun kustom Anda.",
        keywords:
          "galeri avatar,avatar tersimpan,koleksi kartun,manajemen avatar,unduh avatar",
      },
    },
    // 马来语 - 针对马来西亚市场
    ms: {
      siteName: "Ugly Avatar",
      home: {
        title:
          "Penjana Avatar Hodoh-Comel - Cipta Avatar Kartun yang Menyeronokkan",
        description:
          "Cipta avatar kartun yang menyeronokkan, unik, dan berkesan dengan penjana Ugly Avatar. Sesuaikan warna rambut, warna latar belakang, dan ekspresi, simpan dan kongsi reka bentuk kegemaran anda.",
        keywords:
          "penjana avatar,avatar kartun,avatar hodoh-comel,avatar rawak,avatar diperibadikan,avatar SVG,avatar percuma",
      },
      generator: {
        title:
          "Cipta Avatar Hodoh-Comel Anda - Penjana Avatar Kartun yang Menyeronokkan",
        description:
          "Hasilkan avatar kartun hodoh-comel unik anda sendiri dengan alat dalam talian percuma kami. Sesuaikan rambut, warna, ekspresi dan muat turun atau kongsi dengan rakan.",
        keywords:
          "hasilkan avatar,muka kartun tersuai,pencipta avatar,avatar lucu,kartun diperibadikan",
      },
      gallery: {
        title: "Koleksi Avatar Saya - Galeri Ugly Avatar",
        description:
          "Lihat dan urus avatar kartun hodoh-comel yang anda telah simpan. Muat turun, kongsi, atau padam koleksi avatar kartun tersuai anda.",
        keywords:
          "galeri avatar,avatar tersimpan,koleksi kartun,pengurusan avatar,muat turun avatar",
      },
    },
  };

  // 如果请求的语言不存在，使用英语作为后备
  const localeSeoData = seoData[locale] || seoData.en;
  const pageSeoData = localeSeoData[page] || localeSeoData.home;

  return {
    title: pageSeoData.title,
    siteName: localeSeoData.siteName,
    description: pageSeoData.description,
    keywords: pageSeoData.keywords,
    locale: locale,
  };
}

/**
 * 更新页面的SEO元数据
 * @param {Object} metaData SEO元数据对象
 */
export function updatePageMetadata(metaData) {
  // 更新标题
  document.title = metaData.title;

  // 更新meta描述
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute("content", metaData.description);
  } else {
    metaDescription = document.createElement("meta");
    metaDescription.setAttribute("name", "description");
    metaDescription.setAttribute("content", metaData.description);
    document.head.appendChild(metaDescription);
  }

  // 更新meta关键词
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute("content", metaData.keywords);
  } else {
    metaKeywords = document.createElement("meta");
    metaKeywords.setAttribute("name", "keywords");
    metaKeywords.setAttribute("content", metaData.keywords);
    document.head.appendChild(metaKeywords);
  }

  // 更新Open Graph标签
  updateOpenGraphTags(metaData);
}

/**
 * 更新Open Graph标签
 * @param {Object} metaData SEO元数据对象
 */
function updateOpenGraphTags(metaData) {
  // 更新og:title
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute("content", metaData.title);
  }

  // 更新og:description
  let ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute("content", metaData.description);
  }

  // 更新og:locale
  let ogLocale = document.querySelector('meta[property="og:locale"]');
  if (ogLocale) {
    ogLocale.setAttribute("content", metaData.locale);
  } else {
    ogLocale = document.createElement("meta");
    ogLocale.setAttribute("property", "og:locale");
    ogLocale.setAttribute("content", metaData.locale);
    document.head.appendChild(ogLocale);
  }

  // 更新twitter:title
  let twitterTitle = document.querySelector('meta[property="twitter:title"]');
  if (twitterTitle) {
    twitterTitle.setAttribute("content", metaData.title);
  }

  // 更新twitter:description
  let twitterDescription = document.querySelector(
    'meta[property="twitter:description"]'
  );
  if (twitterDescription) {
    twitterDescription.setAttribute("content", metaData.description);
  }
}
